{
    "header": "הוסף משתמש חדש",
    "firsName": "שם פרטי",
    "lastName" : "שם משפחה",
    "email": "כתובת מייל",
    "password": "סיסמה",
    "hasAccess": "לאפשר שליטה"
}